
const documentos = {

    bomberos: {

        tituloSeccion: "Resultados generales",

        items: [

            {
                titulo: "Resultados individuales",

                descripcion:
                    "Resultados oficiales de la carrera, incluyendo tiempos y posiciones de los participantes.",

                imagen:"https://ik.imagekit.io/twn1y7ldf/Nuevo_ATACA/resultados_individuales.jpg",

                boton: "Ver resultados",

                link: "https://drive.google.com/file/d/1LGevewk4UQtoACXoQRhcQZyYx3nErq62/view?usp=sharing"
            },

            {
                titulo: "Resultados grupales",

                descripcion:
                    "Resultados por equipos o grupos, mayor inscritos por equipo.",

                imagen:"https://ik.imagekit.io/twn1y7ldf/Nuevo_ATACA/resultados_grupales.jpg",

                boton: "Ver resultados",

                link: "https://drive.google.com/file/d/152ckCiqbY8rBNLx7i7ggwe1OfKGJYEZi/view?usp=sharing"
            }

        ]

    },

    chiguata_trail: {

        tituloSeccion: "Resultados generales",

        items: [

            {
                titulo: "Resultados tercera fecha ",

                descripcion:
                    "Resultados oficiales de la carrera, incluyendo tiempos y posiciones de los participantes.",

                imagen:"https://ik.imagekit.io/twn1y7ldf/Nuevo_ATACA/tiempos%204ta%20fecha.jpg",

                boton: "Ver resultados",

                link: "https://drive.google.com/file/d/1qup0pAU8ZKNWt3b3NKboRDpP1hAIWUKX/view?usp=sharing"
            },

            {
                titulo: "Resultados acumulativos por categoría",

                descripcion:
                    "Resultados oficiales de la competencia, acumulativos por categoría de las 3 fechas",

                imagen:"https://ik.imagekit.io/twn1y7ldf/Nuevo_ATACA/AQP_TRS_CHIGUATA_2026/RESULTADOS_1.jpg",

                boton: "Ver resultados",

                link: "https://drive.google.com/file/d/18ccyQ1G-pXiMHykwATG2epSwPXiqIjBL/view?usp=sharing"
            },

            {
                titulo: "Resultados acumulativos generales",

                descripcion:
                    "Resultados oficiales de la competencia, acumulativos por tiempos",

                imagen:"https://ik.imagekit.io/twn1y7ldf/Nuevo_ATACA/AQP_TRS_CHIGUATA_2026/RESULTADOS_2.jpg",

                boton: "Ver resultados",

                link: "https://drive.google.com/file/d/1g1Nh-siRmO3KcJTyM9AP6Bp2MhspmhGM/view?usp=sharing"
            },
            
            {
                titulo: "Resultados acumulativos grupales",

                descripcion:
                    "Resultados oficiales de la competencia, acumulativos por equipos",

                imagen:"https://ik.imagekit.io/twn1y7ldf/Nuevo_ATACA/AQP_TRS_CHIGUATA_2026/RESULTADOS_3.jpg",

                boton: "Ver resultados",

                link: "https://drive.google.com/file/d/1Sha7lTE2L-48WAV0-cWowURb-5ZjG9Fl/view?usp=sharing"
            },

        ]

    },

    corro_ninos_2026: {

        tituloSeccion: "DOCUMENTOS IMPORTANTES",

        items: [

            {
                titulo: "Deslinde de responsabilidad",

                descripcion:
                    "Documento que exime de responsabilidad a la organización del evento, firmado por los participantes o sus representantes legales.",

                imagen:"https://ik.imagekit.io/twn1y7ldf/Nuevo_ATACA/CORRO%20POR%20LOS%20NINOS%202026/doc1.jpg",

                boton: "Ver documento",

                link: "https://drive.google.com/file/d/14rFRcXXlZcJibQvfSXZd3r66jVBpWZru/view?usp=sharing"
            },

            {
                titulo: "Autorización de menores de edad",

                descripcion:
                    "Documento que permite a los menores de edad participar en el evento, firmado por sus padres o tutores legales.",

                imagen:"https://ik.imagekit.io/twn1y7ldf/Nuevo_ATACA/CORRO%20POR%20LOS%20NINOS%202026/doc2.jpg",

                boton: "Ver documento",

                link: "https://drive.google.com/file/d/1xulkF-_FWJUkwvKxd9xVWlI2Rb8fgCAL/view?usp=sharing"
            },

            {
                titulo: "Responsabilidad del sensor",

                descripcion:
                    "Documento que compromete al uso correcto del sensor de cronometraje, como también su devolución",

                imagen:"https://ik.imagekit.io/twn1y7ldf/Nuevo_ATACA/CORRO%20POR%20LOS%20NINOS%202026/PERRO%207.jpg",

                boton: "Ver documento",

                link: "https://drive.google.com/file/d/1gLCZVGDiI9BWZXzoVbbGj-7Aizebm5uQ/view?usp=sharing"
            }

        ]

    },

    corro_ninos_2026_bases: {

        tituloSeccion: "SOBRE LA CARRERA",

        items: [

            {
                titulo: "Bases generales",

                descripcion:
                    "Documento que establece las reglas y regulaciones de la carrera, incluyendo categorías, distancias y criterios de participación.",

                imagen:"https://ik.imagekit.io/twn1y7ldf/Nuevo_ATACA/CORRO%20POR%20LOS%20NINOS%202026/3.jpg?updatedAt=1790180980631",

                boton: "Consultar bases",

                link: "https://drive.google.com/file/d/1iVif_UBTPQD-mddSIssNgiN9Bler5DLn/view?usp=sharing"
            }
        ]

    },

    lsl_mtb_joya_2026: {

        tituloSeccion: "RESULTADOS",

        items: [

            {
                titulo: "Resultados Segunda Fecha",

                descripcion:
                    "Conoce los tiempos y posiciones de la segunda serie de LSL MTB 2026: EL SEÑOR DE LA JOYA",

                imagen:"https://ik.imagekit.io/twn1y7ldf/Nuevo_ATACA/LSL%20MTB%20JOYA%202026/champion3.jpg",

                boton: "Ver Resultados",

                link: "https://drive.google.com/file/d/1Ufbfw-8tZR56WtbiJwngrb8U3ma_cWBC/view?usp=sharing"
            },

            {
                titulo: "Resultados Acumulativos Grupales",

                descripcion:
                    "Conoce las posiciones de cada equipo en las dos fechas del LSL MTB 2026",

                imagen:"https://ik.imagekit.io/twn1y7ldf/Nuevo_ATACA/LSL%20MTB%20JOYA%202026/CHAMPIONS4.jpg",

                boton: "Ver Resultados",

                link: "https://drive.google.com/file/d/10Ft_BdxEuqq9rmifCZei0CkJGfdZPSTI/view?usp=sharing"
            }
        ]

    },

    chilina_trail: {

        tituloSeccion: "Resultados generales",

        items: [

            {
                titulo: "Resultados cuarta fecha ",

                descripcion:
                    "Resultados oficiales de la carrera, incluyendo tiempos y posiciones de los participantes.",

                imagen:"https://ik.imagekit.io/twn1y7ldf/Nuevo_ATACA/AQP_TRS_CHILINA_2026/grupal.jpg",

                boton: "Ver resultados",

                link: "https://drive.google.com/file/d/1cXHgxin_XYgDuUGpTe3onRdSC4BVGsFd/view?usp=sharing"
            },

            {
                titulo: "Resultados acumulativos por categoría",

                descripcion:
                    "Resultados oficiales, primeros puestos de cada categoría de las 4 fechas",

                imagen:"https://ik.imagekit.io/twn1y7ldf/Nuevo_ATACA/AQP_TRS_CHILINA_2026/categoria.jpg",

                boton: "Ver resultados",

                link: "https://drive.google.com/file/d/1iNT2LdckHTcSbfNs-3dAs32CSiXNyV_o/view?usp=sharing"
            },

            {
                titulo: "Resultados acumulativos generales",

                descripcion:
                    "Resultados oficiales, primeros puesto acreedores del premio en efectivo",

                imagen:"https://ik.imagekit.io/twn1y7ldf/Nuevo_ATACA/AQP_TRS_CHILINA_2026/individual.jpg",

                boton: "Ver resultados",

                link: "https://drive.google.com/file/d/1t_zhP40gV_3lQxap2fcDcMlShW7Ec5yv/view?usp=sharing"
            },
            
            {
                titulo: "Resultados acumulativos grupales",

                descripcion:
                    "Resultados oficiales de la competencia, acumulativos por equipos",

                imagen:"https://ik.imagekit.io/twn1y7ldf/Nuevo_ATACA/AQP_TRS_CHILINA_2026/grupal2.jpg",

                boton: "Ver resultados",

                link: "https://drive.google.com/file/d/1yZm2x_rQFilZfOZuyUCGXFVPG5VOkKTz/view?usp=sharing"
            },

        ]

    },

};

export default documentos;